import React, { Component } from "react";

class PageSesion extends Component {

    render(){
        return(
            <h1>Pagina de Sesion</h1>
        )
    }
}

export default PageSesion;